/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var R = require("ramda");
var stringUtil = require("../util/string");

//-------------------------------------------
// Creates a function that resolves each of the
// parameters of a group definition.
function createGroupResolver(aggregatorFactory, comparerFactory, formatterFactory) {
    return function (context, group, isDescending) {
        return R.merge(group, {
            aggregators: (group.aggregators !== undefined ? aggregatorFactory(context, group.aggregators) : undefined),
            comparer: (group.comparer !== undefined ? comparerFactory(context, group.comparer, isDescending) : undefined),
            formatter: (group.formatter !== undefined ? formatterFactory(context, group.formatter) : undefined),
            getter: (group.getter !== undefined ? formatterFactory(context, group.getter) : undefined)
        });
    };
}


//-------------------------------------------
// Default implementation of the group factory
function defaultFactory(id) {
    if (stringUtil.isNullOrWhitespace(id)) { throw new Error("group factory id must be non-empty string."); }
    var pair = id.split(":");
    var groupType = (pair[1] || "").toLowerCase();
    var groupField = pair[0];
    switch (groupType) {
    case "default":
        return {
            aggregateCollapsed: false,
            aggregators: [],
            comparer: "value:default",
            formatter: "".concat(groupField, ":group-title"),
            getter: "".concat(groupField, ":lowercase")
        };
    case "sensitive":
        return {
            aggregateCollapsed: false,
            aggregators: [],
            comparer: "value:default",
            formatter: "".concat(groupField, ":group"),
            getter: "".concat(groupField, ":default")
        };
    default:
        throw new Error("`".concat(id, "` group type is not supported."));
    }
}


//-------------------------------------------
// Accepts a factory function and returns a function
// that resolves a group.
function init(factory, aggregatorFactory, comparerFactory, formatterFactory) {
    var groupResolver = createGroupResolver(aggregatorFactory, comparerFactory, formatterFactory);
    return function groupFactoryResolver(context, value, isDescending) {
        var result;
        if (Array.isArray(value)) {
            var i, l = value.length, current = [];
            for (i = 0; i < l; i += 1) {
                current = current.concat(groupFactoryResolver(context, value[i]));
            }
            result = current;
        } else if (R.is(Object, value)) {
            result = [groupResolver(context, value, isDescending)];
        } else {
            result = [groupResolver(context, factory.call(context, value), isDescending)];
        }
        return result;
    };
}


module.exports = {
    defaultFactory: init(
        defaultFactory,
        require("./aggregatorFactory").defaultFactory,
        require("./comparerFactory").defaultFactory,
        require("./formatterFactory").defaultFactory
    ),
    init: init
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/ko-grid/groupFactory.js
// module id = 439
// module chunks = 49